// ============================================
// SammyGas - Constantes de la aplicación
// ============================================

// Configuración de la API
export const API_BASE_URL = '/api/v1';

// Información de la aplicación
export const APP_NAME = 'SammyGas';
export const APP_VERSION = '1.0.0';

// Keys para localStorage
export const STORAGE_KEYS = {
  TOKEN: 'sammygas_token',
  USER: 'sammygas_user',
  CART: 'sammygas_cart',
  SELECTED_ZONE: 'sammygas_zone',
};

// Métodos de pago disponibles
export const PAYMENT_METHODS = {
  CASH: {
    id: 'cash',
    label: 'Efectivo',
    description: 'Pago en efectivo al recibir el pedido',
    icon: '💵',
  },
  TRANSFER: {
    id: 'transfer',
    label: 'Transferencia',
    description: 'Transferencia bancaria',
    icon: '🏦',
  },
  CARD: {
    id: 'card',
    label: 'Tarjeta',
    description: 'Pago con tarjeta al recibir',
    icon: '💳',
  },
  MERCADOPAGO: {
    id: 'mercadopago',
    label: 'Tarjeta (MercadoPago)',
    description: 'Pago seguro con tarjeta de crédito o débito',
    icon: '💳',
  },
};

// Estados de pedidos con colores y labels
export const ORDER_STATUSES = {
  PENDING: {
    id: 'pending',
    label: 'Pendiente',
    description: 'Pedido recibido, esperando confirmación',
    color: '#f59e0b', // amber-500
    bgColor: '#fef3c7', // amber-100
    textColor: '#92400e', // amber-800
    icon: '⏳',
  },
  CONFIRMED: {
    id: 'confirmed',
    label: 'Confirmado',
    description: 'Pedido confirmado, en preparación',
    color: '#3b82f6', // blue-500
    bgColor: '#dbeafe', // blue-100
    textColor: '#1e40af', // blue-800
    icon: '✅',
  },
  IN_TRANSIT: {
    id: 'in_transit',
    label: 'En camino',
    description: 'El repartidor está en camino',
    color: '#8b5cf6', // violet-500
    bgColor: '#ede9fe', // violet-100
    textColor: '#5b21b6', // violet-800
    icon: '🚚',
  },
  DELIVERED: {
    id: 'delivered',
    label: 'Entregado',
    description: 'Pedido entregado exitosamente',
    color: '#10b981', // emerald-500
    bgColor: '#d1fae5', // emerald-100
    textColor: '#065f46', // emerald-800
    icon: '🎉',
  },
  CANCELLED: {
    id: 'cancelled',
    label: 'Cancelado',
    description: 'Pedido cancelado',
    color: '#ef4444', // red-500
    bgColor: '#fee2e2', // red-100
    textColor: '#991b1b', // red-800
    icon: '❌',
  },
};

// URL base para WhatsApp
export const WHATSAPP_BASE_URL = 'https://wa.me';

// Número de WhatsApp del negocio (se puede sobreescribir con config del backend)
export const DEFAULT_WHATSAPP_NUMBER = '';

// Configuración de envíos
export const SHIPPING_CONFIG = {
  FREE_SHIPPING_THRESHOLD: 100000, // Envío gratis a partir de $100.000
  DEFAULT_SHIPPING_COST: 5000, // Costo de envío por defecto
};

// Estados de pago de MercadoPago
export const MP_PAYMENT_STATUSES = {
  PENDING: {
    id: 'pending',
    label: 'Pendiente',
    description: 'El pago está siendo procesado',
    color: '#f59e0b',
  },
  APPROVED: {
    id: 'approved',
    label: 'Aprobado',
    description: 'El pago fue aprobado exitosamente',
    color: '#10b981',
  },
  REJECTED: {
    id: 'rejected',
    label: 'Rechazado',
    description: 'El pago fue rechazado',
    color: '#ef4444',
  },
  IN_PROCESS: {
    id: 'in_process',
    label: 'En proceso',
    description: 'El pago está siendo revisado',
    color: '#3b82f6',
  },
  REFUNDED: {
    id: 'refunded',
    label: 'Reembolsado',
    description: 'El pago fue reembolsado',
    color: '#8b5cf6',
  },
};

// Límites del carrito
export const CART_LIMITS = {
  MAX_QUANTITY_PER_ITEM: 10,
  MIN_ORDER_AMOUNT: 10000, // Pedido mínimo $10.000
};

// Configuración de notificaciones toast
export const TOAST_CONFIG = {
  DURATION: 3000,
  POSITION: 'top-center',
};

// Rutas de la aplicación
export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  REGISTER: '/register',
  PROFILE: '/profile',
  PRODUCTS: '/products',
  PRODUCT_DETAIL: '/products/:slug',
  CART: '/cart',
  CHECKOUT: '/checkout',
  ORDERS: '/orders',
  ORDER_DETAIL: '/orders/:code',
  PROMOTIONS: '/promotions',
};
